import { createContext, useContext } from "react";

const TicketPopupContext = createContext({
  openPopup: () => {},
  closePopup: () => {},
  focusPopup: () => {},
});

export const useTicketPopup = () => useContext(TicketPopupContext);

export default TicketPopupContext;
